export function onUpgradeNeeded(event) {
  const db = event.target.result;

  // AGENTS
  if (!db.objectStoreNames.contains("agents")) {
    const store = db.createObjectStore("agents", { keyPath: "id" });
    store.createIndex("userId", "userId");
    store.createIndex("lineId", "lineId");
  }
  
  // AGENT LINES
  if (!db.objectStoreNames.contains("agentLines")) {
    const store = db.createObjectStore("agentLines", { keyPath: "id" });
    store.createIndex("userId", "userId");
    store.createIndex("lineId", "lineId");
  }

  // LINES
  if (!db.objectStoreNames.contains("lines")) {
    const store = db.createObjectStore("lines", { keyPath: "id" });
  }

  // CONVERSATIONS
  if (!db.objectStoreNames.contains("conversations")) {
    const store = db.createObjectStore("conversations", { keyPath: "id" });
    store.createIndex("status", "status");
    store.createIndex("lineId_status", ["lineId", "status"]);
    store.createIndex("lineId_userId", ["lineId", "userId"]);
  }

  // EVENTS (mensajes / comentarios / cierre)
  if (!db.objectStoreNames.contains("events")) {
    const store = db.createObjectStore("events", { keyPath: "id" });
    store.createIndex("tempId", "tempId", { unique: true });
    store.createIndex("lineId_chatId", ["lineId", "chatId"]);
  }

  // SYNC STATE
  if (!db.objectStoreNames.contains("syncState")) {
    const store = db.createObjectStore("syncState", { keyPath: "id" });
  }

  // Quickly Replies
  if (!db.objectStoreNames.contains("quicklyReplies")) {
    const store = db.createObjectStore("quicklyReplies", { keyPath: "id" });
  }

  // Files
  if (!db.objectStoreNames.contains("files")) {
    const store = db.createObjectStore("files", { keyPath: "id" });
    store.createIndex("by_scope_entity", ["scope", "entity", "entityId"], { unique: true });
  }
}